import Skeleton from '@mui/material/Skeleton';

const SkeletonTitle = () => <Skeleton sx={{ mt: 2 }} height={40} width="25%" />;

const SkeletonTextBlock = () => (
	<Skeleton sx={{ mt: 2 }} variant="rounded" width="100%" height={70} />
);

const FAQSkeleton = () => (
	<>
		<SkeletonTitle />
		<SkeletonTextBlock />
		<SkeletonTextBlock />
		<SkeletonTextBlock />
		<SkeletonTextBlock />
		<SkeletonTitle />
		<SkeletonTextBlock />
		<SkeletonTextBlock />
		<SkeletonTextBlock />
		<SkeletonTextBlock />
	</>
);

export default FAQSkeleton;
